module.exports = __webpack_public_path__ + "img/wheelM1.5af8e71e.png";